<template>
  <div class="container">
    <!-- 导航 -->
    <h5>您当前所在位置： 首页 >> {{neirong.TZBT}}</h5>

    <div class="gonggao-con">
      <!-- 标题 -->
      <h2 class="gonggao-title">{{neirong.TZBT}}</h2>
      <!-- 发布人 -->
      <div class="datefrom">
        <span>{{neirong.FBSJ}}</span>
        <span> | 发布人：</span>
        <!-- <span>{{neirong.FBR}}</span> -->
        <span>无</span>
      </div>
      <!-- 发布内容 -->
      <div :style="fjid ? pubs : '' ">
        <div v-html="neirong.TZNR"></div>
      </div>

      <!-- 附件下载 -->
      <div class="fjdl" v-if="fjid">
        <span>附件： {{neirong.FILENAME}}</span><a @click="download" href="javascript:;">下载</a>
      </div>

    </div>



  </div>
</template>


<script>
var configLink = require('../../../../config/index')
export default {
  data(){
    return{
      // 内容
      neirong:{},

      //储存附件id，并判断是否存在
      fjid:'',

      //有无附件id时加底边框
      pubs:{borderBottom: '1px solid #c00'}
    }
  },


  methods:{
    getInfo(id){
      this.get({
          url: 'getTzggById',
          data:{
            tzid:id
          }
      }, (res) => {
        console.log(res);
        this.neirong=res.data.list[0]
      })
    },

    //下载附件
    download(){
      window.open(`/dev-api/messagemanage/downloadFile?fid=${this.fjid}`)
    }
  },

  created(){
    this.getInfo(this.$route.query.noticeid)
    console.log(this.$route.query);
    this.fjid=this.$route.query.fid

  }
}
</script>


<style scoped>
.container{
    width: 1000px;
    margin: 0 auto;
    min-height: 100px;
    margin-top: 15px;
    margin-bottom: 45px;
    background-color: #e3eeff;
}
h5{
  height: 30px;
  line-height: 30px;
  border-bottom: 2px solid #c00000;
  font-size: 14px;
  color: #6e6e6e;
  padding-left: 20px;
}
.gonggao-con{
    padding: 0 20px 54px 20px;
    position: relative;
}

.gonggao-title{
    width: 830px;
    text-align: center;
    margin: 0 auto;
    font-size: 24px;
    color: #cc0000;
    height: 90px;
    line-height: 30px;
    margin-top: 30px;
}
.datefrom{
    width: 960px;
    height: 26px;
    background-color: #d6e6ff;
    border-top: 1px solid #a3c7ff;
    text-align: center;
}
.fjdl{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/sy/pages/gg.vue